import { call, put } from 'redux-saga/effects';
import UserClient from '../../api/UserClient';
import { setMobilityPlans } from '../../redux/user/actions';

export default function* getMobilityPlansSaga() {
    try {
        const plans = yield call(UserClient.getMobilityPlans);

        const plansRedux = plans.map(
            ({
                billingGroupDiscount,
                billingGroupId,
                id,
                name,
                period,
                periodicTimeWallet,
                price,
                systemCreditIncluded,
            }) => ({
                billingGroupDiscount,
                billingGroupId,
                id,
                name,
                period,
                periodicTimeWallet,
                price,
                systemCreditIncluded,
            })
        );

        yield put(setMobilityPlans(plansRedux));

        return plansRedux;
    } catch (error) {
        console.error('[getMobilityPlansSaga]', error);
        return [];
    }
}
